import React from "react";
import { Link } from "react-router-dom";
import { startLogout } from "../actions/auth";

const DropdownMenu = () => (
    <div className="header__content header__dropdown-menu">
        <div className="header__dropdown-menu__item"><Link to="/dashboard">Dashboard</Link></div>
        <div className="header__dropdown-menu__item"><Link to="/profile">Profile</Link></div>
        <div className="header__dropdown-menu__item" onClick={ startLogout() }>Logout</div>           
    </div>  
)

export default DropdownMenu;


// WEBPACK FOOTER //
// ./src/components/DropdownMenu.js